import { DialogTrigger } from "react-aria-components";
import { IMDSFloatingOverlayProps, MDSFloatingOverlaySlotName } from "./floating-overlay.types";
import { MDSDialog } from "../dialog/dialog";
import {
  StyledContentContainer,
  StyledHeader,
  StyledContent,
  StyledMDSPopover,
} from "./floating-overlay.style";
import { getSlots } from "@/mds/utils/slots";

export const MDSFloatingOverlay = (props: IMDSFloatingOverlayProps) => {
  const { isOpen, onOpenChange, children, dialogProps, popoverProps, triggerProps } = props;

  const trigger = getSlots(children, MDSFloatingOverlaySlotName.Trigger);
  const headerRight = getSlots(children, MDSFloatingOverlaySlotName.HeaderRight);
  const headerLeft = getSlots(children, MDSFloatingOverlaySlotName.HeaderLeft);
  const headerContent = getSlots(children, MDSFloatingOverlaySlotName.HeaderContent);
  const content = getSlots(children, MDSFloatingOverlaySlotName.Content);

  const hasHeader = headerLeft || headerContent || headerRight;

  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={onOpenChange} {...triggerProps}>
      {trigger}
      <StyledMDSPopover {...popoverProps}>
        <MDSDialog {...dialogProps}>
          <StyledContentContainer>
            {hasHeader && (
              <StyledHeader>
                {headerLeft}
                {headerContent}
                {headerRight}
              </StyledHeader>
            )}
            <StyledContent>{content}</StyledContent>
          </StyledContentContainer>
        </MDSDialog>
      </StyledMDSPopover>
    </DialogTrigger>
  );
};
